var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4309_21903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 0.47998C5.63807 0.47998 0.480469 5.63758 0.480469 12C0.480469 18.3624 5.63807 23.52 12.0005 23.52C18.3629 23.52 23.5205 18.3624 23.5205 12C23.5205 5.63758 18.3629 0.47998 12.0005 0.47998ZM9.18047 16.7748H6.84767V9.26758H9.18047V16.7748ZM7.99967 8.34598C7.26287 8.34598 6.78647 7.82398 6.78647 7.17838C6.78647 6.51958 7.27727 6.01318 8.02967 6.01318C8.78207 6.01318 9.24287 6.51958 9.25727 7.17838C9.25727 7.82398 8.78207 8.34598 7.99967 8.34598ZM17.7005 16.7748H15.3677V12.6144C15.3677 11.646 15.0293 10.9884 14.1857 10.9884C13.5413 10.9884 13.1585 11.4336 12.9893 11.862C12.9269 12.0144 12.9113 12.2304 12.9113 12.4452V16.7736H10.5773V11.6616C10.5773 10.7244 10.5473 9.94078 10.5161 9.26638H12.5429L12.6497 10.3092H12.6965C13.0037 9.81958 13.7561 9.09718 15.0149 9.09718C16.5497 9.09718 17.7005 10.1256 17.7005 12.336V16.7748Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4309_21903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogles);
export default __webpack_public_path__ + "static/media/googles.c4d38847602321de0ee4e27a6f35810b.svg";
export { ForwardRef as ReactComponent };